import { useCheckpointRoutesDashboardContext } from '../context/CheckpointRoutesDashboardContext';
import useCheckpointRoutesDashboardColumns from './useCheckpointRoutesDashboardColumns';

export const useCheckpointRoutesDashboard = () => {
  const {
    aggregations,
    selectedSchedules,
    mainLoading,
    orgId,
    groupBy,
    openTimelineEvents,
    intl,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    queryDivisionIds,
    disabledDate,
    setSelectedSchedules,
    setScheduleSelectorLoading,
    toggle,
    isOpen,
  } = useCheckpointRoutesDashboardContext();

  const columns = useCheckpointRoutesDashboardColumns();

  return {
    aggregations,
    selectedSchedules,
    mainLoading,
    orgId,
    groupBy,
    openTimelineEvents,
    intl,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    queryDivisionIds,
    disabledDate,
    setSelectedSchedules,
    setScheduleSelectorLoading,
    toggle,
    isOpen,
    columns,
  };
};
